/* Template: Repeater - gallery
   ========================================================================== */


template.repeater_gallery = function() {

	function updateCaption(text) {
		$caption.html(text);

		if (text.length) {
			$caption.removeClass('hide');
		} else {
			$caption.addClass('hide');
		}
	}

	/*
		variables
	*/

	var $imagesSlider = $('.gallery-slider .gallery-slider__images>div'),
		$thumbnailsSlider = $('.gallery-slider__thumbnails>div');

	/*
		sliders
	*/
	if ($imagesSlider.length) {
		// images options
		$imagesSlider.slick({
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'linear',
			fade: true,
			draggable: false,
			asNavFor: '.gallery-slider__thumbnails>div',
			prevArrow: '.gallery-slider__navigation .prev-arrow',
			nextArrow: '.gallery-slider__navigation .next-arrow'
		});

		// thumbnails options
		$thumbnailsSlider.slick({
			autoplay: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 1,
			cssEase: 'linear',
			centerMode: true,
			draggable: false,
			focusOnSelect: true,
			asNavFor: '.gallery-slider .gallery-slider__images>div',
			prevArrow: '.gallery-slider__thumbnails .prev-arrow',
			nextArrow: '.gallery-slider__thumbnails .next-arrow',
			responsive: [
				{
					breakpoint: 720,
					settings: {
						centerMode: true,
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}
			]
		});

		/*
			captions
		*/

		var $caption = $('.gallery-slider .caption');

		// get the initial caption text
		var captionText = $('.gallery-slider__images .slick-current .img-caption').text();
		updateCaption(captionText);

		// hide the caption before the image is changed
		$imagesSlider.on('beforeChange', function() {
			$caption.addClass('hide');
		});

		// update the caption after the image is changed
		$imagesSlider.on('afterChange', function() {
			captionText = $('.gallery-slider__images .slick-current .img-caption').text();
			updateCaption(captionText);
		});
	}
};
